(() => {
  const Origyn = {
    revealObserver: null,

    init() {
      this.initReveals();
      this.initScrollSections();
    },

    initReveals(scope = document) {
      const elements = scope.querySelectorAll(
        '.origyn-reveal:not([data-origyn-ready])'
      );

      if (!elements.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        elements.forEach((element) => {
          element.dataset.origynReady = 'true';
          element.classList.add('is-visible');
        });

        return;
      }

      if (!this.revealObserver) {
        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const delay = Number(entry.target.dataset.origynDelay || 0);

              window.setTimeout(() => {
                entry.target.classList.add('is-visible');
              }, delay);

              this.revealObserver.unobserve(entry.target);
            });
          },
          {
            threshold: 0.16,
            rootMargin: '0px 0px -8% 0px'
          }
        );
      }

      elements.forEach((element) => {
        element.dataset.origynReady = 'true';
        this.revealObserver.observe(element);
      });
    },

    initScrollSections(scope = document) {
      const sections = scope.querySelectorAll(
        '[data-origyn-scroll-section]:not([data-origyn-scroll-ready])'
      );

      sections.forEach((section) => {
        section.dataset.origynScrollReady = 'true';

        const progressBar = section.querySelector(
          '[data-origyn-progress-bar]'
        );

        const updateSection = () => {
          const rect = section.getBoundingClientRect();
          const scrollDistance = Math.max(
            section.offsetHeight - window.innerHeight,
            1
          );

          const travelled = Math.min(
            Math.max(-rect.top, 0),
            scrollDistance
          );

          const progress = travelled / scrollDistance;

          section.style.setProperty('--origyn-progress', progress);

          if (progressBar) {
            progressBar.style.width = `${progress * 100}%`;
          }

          section.dispatchEvent(
            new CustomEvent('origyn:scroll-progress', {
              detail: { progress }
            })
          );
        };

        section.origynUpdate = updateSection;
        updateSection();
      });

      this.requestScrollUpdate();
    },

    updateScrollSections() {
      document
        .querySelectorAll('[data-origyn-scroll-ready]')
        .forEach((section) => {
          if (typeof section.origynUpdate === 'function') {
            section.origynUpdate();
          }
        });
    },

    requestScrollUpdate() {
      if (this.scrollTicking) return;

      this.scrollTicking = true;

      window.requestAnimationFrame(() => {
        this.updateScrollSections();
        this.scrollTicking = false;
      });
    }
  };

  const initialise = () => Origyn.init();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }

  window.addEventListener(
    'scroll',
    () => Origyn.requestScrollUpdate(),
    { passive: true }
  );

  window.addEventListener('resize', () => {
    Origyn.initScrollSections();
    Origyn.requestScrollUpdate();
  });

  document.addEventListener('shopify:section:load', (event) => {
    Origyn.initReveals(event.target);
    Origyn.initScrollSections(event.target);
  });

  window.Origyn = Origyn;
})();